/**
 * PDF generation is 100% server-side (server/pdf.js).
 * The server fetches product images directly from supplier CDNs — no CORS,
 * no domain whitelist, no image storage needed.
 */
export async function downloadPDF(presentation, distributor, getToken, onProgress) {
  onProgress?.('Generating PDF...');
  const token = await getToken();
  // Diagnostic: what's actually being sent to the server.
  // Remove this console.log once PDF generation is verified working with all toggles.
  console.log('PDF payload — show_pricing:', presentation.show_pricing,
    'additional_charges:', presentation.additional_charges,
    'first product show_price_grid:', presentation.products?.[0]?.show_price_grid,
    'first product show_all_colors:', presentation.products?.[0]?.show_all_colors,
    'first product pricing tiers:', presentation.products?.[0]?.product?.pricing?.length);
  const response = await fetch('/api/presentations/pdf', {
    method: 'POST',
    headers: { 'Content-Type':'application/json', Authorization:`Bearer ${token}` },
    body: JSON.stringify({
      name:                presentation.name,
      client_name:         presentation.client_name,
      show_pricing:        presentation.show_pricing,
      additional_charges:  presentation.additional_charges,
      products:            presentation.products,
    }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'PDF generation failed' }));
    throw new Error(err.error || `Server error ${response.status}`);
  }
  onProgress?.('Downloading...');
  const blob     = await response.blob();
  const url      = URL.createObjectURL(blob);
  const filename = `${distributor.company} — ${presentation.name}.pdf`.replace(/[/\\?%*:|"<>]/g,'-');
  const a = document.createElement('a');
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
